import { supabase } from '../supabaseClient'
import { TasaMetabolica } from './estres-termico'

// ===== Cálculos de estrés térmico por local/puesto de trabajo (multi-empresa) =====
// Mismo patrón que gestion-tecnica-ruido.ts / noise_calculations: inputs y
// resultado se guardan como jsonb libre, tipados aquí para que el resto del
// código (formulario, PDF) no maneje `any`.

export interface HeatStressCalculationInputs {
  tg: number
  thn: number
  ta?: number
  tasaTrabajo: TasaMetabolica
  porcentajeTiempoTrabajado: number
  aclimatado: boolean
  ambiente: 'interior' | 'exterior'
}

export interface HeatStressCalculationResultado {
  wbgt: number
  mPromedio: number
  categoria: TasaMetabolica
  limite: number
  cumple: boolean
}

export interface HeatStressCalculationRow {
  id: string
  company_id: string
  job_position_id: string | null
  descripcion: string
  ambiente: 'interior' | 'exterior'
  inputs: HeatStressCalculationInputs
  resultado: HeatStressCalculationResultado
  cumple_normativa: boolean
  created_by: string | null
  created_at: string
  job_position_name: string | null
}

export interface CreateHeatStressCalculationInput {
  companyId: string
  jobPositionId?: string
  descripcion: string
  ambiente: 'interior' | 'exterior'
  inputs: HeatStressCalculationInputs
  resultado: HeatStressCalculationResultado
  cumpleNormativa: boolean
  createdBy: string | null
}

export async function createHeatStressCalculation(input: CreateHeatStressCalculationInput): Promise<void> {
  const { error } = await supabase.from('heat_stress_calculations').insert({
    company_id: input.companyId,
    job_position_id: input.jobPositionId ?? null,
    descripcion: input.descripcion,
    ambiente: input.ambiente,
    inputs: input.inputs,
    resultado: input.resultado,
    cumple_normativa: input.cumpleNormativa,
    created_by: input.createdBy,
  })
  if (error) throw error
}

export async function fetchHeatStressCalculations(companyId: string): Promise<HeatStressCalculationRow[]> {
  if (!companyId) return []
  const { data, error } = await supabase
    .from('heat_stress_calculations')
    .select('id, company_id, job_position_id, descripcion, ambiente, inputs, resultado, cumple_normativa, created_by, created_at, job_positions(name)')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return (data ?? []).map((r: any) => ({
    id: r.id,
    company_id: r.company_id,
    job_position_id: r.job_position_id,
    descripcion: r.descripcion,
    ambiente: r.ambiente,
    inputs: r.inputs,
    resultado: r.resultado,
    cumple_normativa: r.cumple_normativa,
    created_by: r.created_by,
    created_at: r.created_at,
    job_position_name: r.job_positions?.name ?? null,
  })) as HeatStressCalculationRow[]
}
